import { Card, Col, Divider, Form, Input, Layout, Row, Switch } from "antd";
import { toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormActionButton from "src/components/common/FormActionButton";
import { messages } from "src/constants/messages";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { longToDate } from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

import {
  CalendarOutlined,
  MailOutlined,
  PhoneOutlined
} from "@ant-design/icons";

const FormItem = Form.Item;
const { TextArea } = Input;
const initialState = {
  noiDungTraLoi: "",
  isHienThi: true
};

const TraLoiGopYForm = ({ status }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isActive } = status;
  const [form] = Form.useForm();
  const { noiDungTraLoi, isHienThi } = initialState;
  const { validateFields, setFieldsValue } = form;
  const { idgopy } = useParams();
  const [itemGopY, setItemGopY] = useState<any>({});
  const [idnhomtulieu, setidnhomtulieu] = useState();
  const [loadingButton, setLoadingButton] = useState(false);
  useEffect(() => {
    if (isActive) {
      getInfo();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["infoChucVu"]);
    };
  }, []);

  /**
   * getInfo : Lấy thông tin
   * @memberof  TraLoiGopYForm
   */
  const getInfo = async () => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      setItemGopY(res);
      setidnhomtulieu(res.tuLieu.idNhomTuLieu);
      setFieldsValue({
        gopy: res,
      });
    } else {
      const configAPI = {
        url: `api/tulieugopy/${idgopy}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infoGopY"
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setidnhomtulieu(response.data.tuLieu.idNhomTuLieu);
          setItemGopY(response.data);
          setFieldsValue({
            gopy: response.data,
          });
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  const goBack = () => {
    navigate(`/quan-tri/tra-loi-gop-y`);
  };

  /**
   * save: Lưu
   * @memberof TraLoiGopYForm
   */
  const save = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData: Lưu dữ liệu
   * @param {object} values
   * @param {boolean} saveQuit
   * @memberof TraLoiGopYForm
   */
  const saveData = async (values: any) => {
    try {
      const data = {
        id: itemGopY.id,
        idTuLieu: itemGopY.tuLieu.id,
        email: itemGopY.email,
        isSuDung: itemGopY.isSuDung,
        ngayGopY: itemGopY.ngayGopY,
        nguoiGopY: itemGopY.nguoiGopY,
        noiDungGopY: itemGopY.noiDungGopY,
        soDienThoai: itemGopY.soDienThoai,
        noiDungTraLoi: values.gopy.noiDungTraLoi,
        isHienThi: values.gopy.isHienThi
      };
      const configAPI = {
        url: `api/tulieugopy/${idgopy}`,
        method: "PUT",
        data: data,
        apiType: "EDIT",
        isShowMessage: true
      };
      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        setLoadingButton(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            Trả lời góp ý
          </h2>
        </Col>
      </div>
      <Card>
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="chucvu-control"
        >
          <Row gutter={24}>
            <Col md={24} xs={24}>
              <p>
                <b>{itemGopY.nguoiGopY}</b>
              </p>
            </Col>
            <Col md={8} xs={24}>
              <i
                style={{
                  float: "left",
                  fontSize: 20,
                  padding: "10px 10px 10px 0"
                }}
              >
                <PhoneOutlined />
              </i>
              <span>Số điện thoại</span>
              <p>
                <b>{itemGopY?.soDienThoai ? itemGopY.soDienThoai : ""}</b>
              </p>
            </Col>
            <Col md={8} xs={24}>
            <i
                style={{
                  float: "left",
                  fontSize: 20,
                  padding: "10px 10px 10px 0"
                }}
              >
                <MailOutlined />
              </i>
              <span>Email</span>
              <p>
                <b>{itemGopY.email ? itemGopY.email : ""}</b>
              </p>
            </Col>
            <Col md={8} xs={24}>
            <i
                style={{
                  float: "left",
                  fontSize: 20,
                  padding: "10px 10px 10px 0"
                }}
              >
                <CalendarOutlined />
              </i>
              <span>Ngày góp ý</span>
              <p>
                <b>{longToDate(itemGopY.ngayGopY)}</b>
              </p>
            </Col>
            <Col md={24} xs={24}>
              <p>
                <b>Nội dung góp ý:</b> {itemGopY.noiDungGopY}
              </p>
            </Col>
            <Col md={24} xs={24}>
              <FormItem
                label="Hiển thị câu hỏi"
                name={["gopy", "isHienThi"]}
                valuePropName="checked"
                initialValue={isHienThi}
              >
                <Switch />
              </FormItem>
            </Col>
            <Col md={24} xs={24}>
              <FormItem
                className="ant-input-group"
                label="Nội dung câu hỏi"
                name={["gopy", "noiDungTraLoi"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED
                  }
                ]}
                initialValue={noiDungTraLoi}
              >
                <TextArea rows={4} placeholder="Nhập nội dung trả lời" />
              </FormItem>
            </Col>
           
          </Row>
          <hr />
          <FormActionButton
            goBack={goBack}
            save={save}
            loadingButton={loadingButton}
          />
        </Form>
      </Card>
    </Layout>
  );
};

export default TraLoiGopYForm;
